import React from 'react';
import { translate } from 'react-i18next';
import {
  FormControl,
  Button,
  FormGroup,
  Form,
  ControlLabel,
  Col,
} from 'react-bootstrap';

class InputsRangeFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      min: '',
      max: '',
    };
  }

  render() {
    const { title, minPlaceholder, maxPlaceholder, onApplyFilter, t } = this.props;
    const { min, max } = this.state;
    return (
      <Form style={this.props.style} horizontal>
        <h4><b>{title}</b></h4>
        <FormGroup controlId="formInlineName">
          <Col componentClass={ControlLabel} style={{ fontWeight: 'unset' }} sm={4}>
            {t('min')}
          </Col>
          <Col sm={8}>
            <FormControl
              type="number"
              placeholder={minPlaceholder}
              onChange={event => this.setState({ min: event.target.value })}
              value={min}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col componentClass={ControlLabel} style={{ fontWeight: 'unset' }} sm={4}>
            {t('max')}
          </Col>
          <Col sm={8}>
            <FormControl
              type="number"
              placeholder={maxPlaceholder}
              onChange={event => this.setState({ max: event.target.value })}
              value={max}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col smOffset={4} sm={4}>
            <Button
              bsStyle="primary"
              style={{ width: '100%' }}
              onClick={() => onApplyFilter(this.state.min, this.state.max)}
            >
              {t('apply')}
            </Button>
          </Col>
          <Col sm={4}>
            <Button
              style={{ width: '100%' }}
              onClick={() => this.setState({ min: '', max: '' }, () => { onApplyFilter(this.state.min, this.state.max) })}
            >
              {t('clear')}
            </Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

InputsRangeFilter.defaultProps = {
  title: '',
  minPlaceholder: 'min',
  maxPlaceholder: 'max',
  onApplyFilter: (min, max) => {},
  t: () => {},
};

export default translate('translations')(InputsRangeFilter);



// WEBPACK FOOTER //
// ./src/components/filter/InputsRangeFilter.js